import { sortBy } from 'lodash';

export default {
  getXeroProfitAndLossReport: (state) => state.xeroProfitAndLossReport,
  profitAndLossItems: (state) => {
    console.log(state.xeroProfitAndLossReports);
    const items = sortBy(
      state.xeroProfitAndLossReports, (r) => r.created,
    );
    const result = items?.reverse()[0]?.profitAndLossItems;
    console.log(result, items);
    return result;
  },
};
